import type { AlpineComponent } from 'alpinejs';
import { Cookies } from '../utils/cookies';

export const currentCountry: AlpineComponent = {
	value: Cookies.get('country_selected') ?? 'DE',

	set(countryCode: string, withoutCookie: boolean) {
		this.value = countryCode;

		if (!withoutCookie) {

			if(countryCode === 'UK') {
				countryCode = 'GB';
			}

			Cookies.set('country_selected', countryCode, {
				expires: new Date(Date.now() + 24 * 60 * 60 * 1000), // Current time + 1 day in milliseconds
				path: '/', // Optional: Specify path if needed\
				secure: true,
			});
		}
	}
};
